<template>
  <div>
    <div>
      <div class="lg:mb-4 flex mx-2 flex-row flex-wrap items-center justify-between overflow-x-auto">
        <div class="flex flex-row">
          <div class="px-2  mt-4  mb-2 lg:mb-0">
            <span class="dark:bg-darkblue-800 dark:text-darkblue-200 font-bold  mr-4 truncate group-hover:text-primary">{{ label }}</span>
          </div>
          <div class="px-2  mt-4 mb-2 lg:mb-0">
            <span class='dark:bg-darkblue-800 dark:text-darkblue-200 badge badge-warning right-0 z-20 badge-count dark:hover:bg-darkblue-900'>
              {{ total }}
            </span>
          </div>
        </div>
        <div class="px-2 mt-4 mb-2 lg:mb-0">
          <base-table-pagination-mini
            :total='totalPage'
            :currentPage='currentPage'
            :perPage='perPage'
            @changeCurrentPage='changeCurrentPage'
          ></base-table-pagination-mini>
        </div>
      </div>
    </div>
    <div v-if="tableData">
      <BaseAccessibleTable
        :rows="tableData"
        :columns="tableColumns"
        :enableScroll="true"
        :maxBodyHeight="350"
        sortKey="label"
        :sortOrder="ariaSortLabel"
        theadClass="border-b-2"
        @row-click="rowClick"
        @sort-click="handleSortClick"
      >
        <template #cell-icon="{ row }">
          <div class="cell flex justify-center items-center">
            <base-button-icon
              ariaLabel="Aplicar filtro y redirigir a notificaciones"
              name="notification"
              iconSize="sm"
              size="xs"
              mode="secondary-phantom-blue"
              @click.stop="rowClick(row)"
            />
          </div>
        </template>

        <template #header-label>
          <span class="inline-flex items-center cursor-pointer">
            <span>Nombre</span>
            <span class="ml-1 text-xs" aria-hidden="true">
              {{ isAscendingInternal ? '▲' : '▼' }}
            </span>
          </span>
        </template>
      </BaseAccessibleTable>
    </div>
  </div>
</template>

<script>
export default {
  name: 'notifications-table',
  props: {
    label: {
      type: String,
      default: 'chart'
    },
    tableData: {
      type: [Array, Object]
    },
    total: {
      type: Number,
      default: 0
    },
    icon: {
      type: String,
      default: ''
    },
    totalPage: {
      type: Number,
      default: 0
    },
    currentPage: {
      type: Number,
      default: 1
    },
    ascendingOrder: {
      type: Boolean,
      default: true
    },
    perPage: {
      type: Number,
      default: 100
    },
  },
  data () {
    return {
      isAscendingInternal: this.ascendingOrder
    }
  },
  components: {
    BaseAccessibleTable: () => import('../tables/BaseAccessibleTable.vue')
  },
  computed: {
    tableColumns () {
      return [
        { key: 'icon', label: '-', width: '55px', align: 'center' },
        { key: 'label', label: 'Nombre', minWidth: '170px', align: 'left' },
        { key: 'sinTramitar', label: 'Sin Archivar', width: '130px', align: 'center' },
        { key: 'fechaUltimaRev', label: 'Última vigilancia correcta', width: '200px', align: 'center' }
      ]
    },
    isSedesTable () {
      return this.label === 'Sedes'
    },
    selectedClientDashboard () {
      return this.$store.getters['dashboard/getSelectedClient']
    },
    isSelectedClientDashboard () {
      return this.selectedClientDashboard !== undefined && this.selectedClientDashboard !== null && this.selectedClientDashboard !== 0
    },
    selectedClientNameDashboard () {
      return this.$store.getters['dashboard/getSelectedClientName']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    ariaSortLabel () {
      return this.isAscendingInternal ? 'ascending' : 'descending'
    }
  },
  watch: {
    ascendingOrder (val) {
      this.isAscendingInternal = val
    }
  },
  methods: {
    formatter: function (row, column) {
      return row.value
    },
    rowClick: function (row) {
      if (this.role === 'AdminDistribuidor') return
      const data = { filters: [] }
      if (this.icon === 'sede') {
        data.filters.push({ type: this.icon, data: { label: row.label, id: row.id, codigo: row.codigo } })
      } else if (this.icon === 'company') {
        data.filters.push({ type: this.icon, data: { label: row.label, id: row.CIF } })
      }
      if ((this.role === 'SuperAdministrador' || this.role === 'SuperAdminDistribuidor' || this.role === 'AdminDistribuidor') && this.isSelectedClientDashboard) {
        data.filters.push({ type: 'cliente', data: { label: this.selectedClientNameDashboard, id: this.selectedClientDashboard } })
      } 
      data.filters.push({ type: 'archivadas', data: { label: 'archivada', id: false } })
      this.$router.push({ name: 'notifications', params: { data: data } })
    },
    changeCurrentPage: async function (numPage) {
      if (this.isSedesTable) {
        this.$emit('changePageSedes', numPage)
      } else {
        this.$emit('changePageCompanies', numPage)
      }
    },
    onSortChange: async function (sortProps) {
      const ascending = sortProps.order === 'ascending' || sortProps.order === null
      if (this.isSedesTable) {
        this.$emit('changeAscendingOrderSedes', ascending)
      } else {
        this.$emit('changeAscendingOrderCompanies', ascending)
      }
    },
    handleSortClick () {
      const nextOrder = this.isAscendingInternal ? 'descending' : 'ascending'
      this.isAscendingInternal = !this.isAscendingInternal
      this.onSortChange({ column: null, prop: 'label', order: nextOrder })
    }
  }
}
</script>

<style scoped>
</style>
